export const MuseLink = ({ children = "Muse", className = "" }) => (
  <a
    href="https://soundforgemuse.com/"
    target="_blank"
    rel="noreferrer"
    data-testid="muse-link"
    className={`text-gold underline decoration-gold/40 underline-offset-2 hover:decoration-gold transition-colors ${className}`}
  >
    {children}
  </a>
);

export const linkifyMuse = (text) => {
  const parts = String(text).split(/(Muse Beats|Muse)/g);
  return parts.map((p, i) =>
    p === "Muse Beats" || p === "Muse" ? <MuseLink key={i}>{p}</MuseLink> : p
  );
};
